import { UserDevice } from './UserDevice';

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  totpAuthenticatorEnabled: boolean;
  lang: string;
  company?: string;
  isRegistered?: boolean;
  isSuperAdmin: boolean;
}

export interface UserCreateResponse extends Pick<User, 'firstName' | 'lastName' | 'email'> {
  publicKeyBase64: string;
}

export interface UserSession extends Pick<User, 'id' | 'firstName' | 'lastName' | 'company' | 'email' | 'lang'> {
  isRegistered: boolean;
  isSuperAdmin: boolean;
  publicKey: string;
  encryptedPrivateKey: string;
  encryptedPrivateKeyRecovery: string;
  encryptedWebDevicePrivateKey: string;
  encryptedRecoveryPassword: string;
  totpAuthenticatorEnabled: boolean;
  devices: Pick<UserDevice, 'peerKey' | 'operatingSystem'>[];
}

/**
 * This interface represent the result of the preflight check for deleting a user
 * It contains all the spaces that are not removed
 * and all the realms that still contains users and not a second admin
 */
export interface CanDeleteUserResponse {
  projectCount: { count: number; realmName: string; realmPublicKey: string; realmId: number }[];
  realmUserCount: { realmName: string; realmPublicKey: string; realmId: number; userCount: number; adminCount: number }[];
}

export enum UserRoleEnum {
  Admin = 'admin',
  User = 'user',
  Guest = 'guest',
}
